<template>
  <FourElement />
  <div class="collection-container">
    <List />
  </div>
  <Log />
  <MixModal />
  <NavSet />
</template>
<script>
import { toRefs, reactive, provide, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import FourElement from './components/FourElement'
import List from './components/List'
import Log from './components/Log'
import MixModal from './components/MixModal'
import NavSet from './components/NavSet'
import { message } from 'ant-design-vue'
import useAPI from 'UseApi'
const {
  nav_get_post_,
  common_querySiteInfo_get_,
  commonConfig_list_post_,
  col_deleteCol_post_,
  col_activeCol_post_,
  col_queryColLog_post_,
  mixCol_page_post_,
  mixCol_saveMixCol_post_,
  mixCol_remove_mixId_get_,
  mixCol_getMixColDetail_mixId_get_,
  mixCol_checkMixCol_post_,
  nav_active_post_
} = useAPI(null, [3426, 4240, 5922, 5390, 7056])
import {
  theme_query_get,
  homepage_strategy_list_post,
  theme_save_post,
  tobpop_list_post,
  tobBar_list_post
} from '@/server/modules/11297'
import { nav_list_post } from '@/server/modules/7773'
export default {
  components: {
    FourElement,
    List,
    Log,
    MixModal,
    NavSet
  },
  setup() {
    const state = reactive({
      themeVisible: false,
      changeId: (e, type) => {
        if (type === 1) {
          state.pcActiveId = e
          state.pcActiveIdVal = null
        } else {
          state.mActiveIdVal = null
          state.mActiveId = e
        }
      },
      cancelNav: () => {
        state.pcActiveIdVal = null
        state.mActiveIdVal = null
        state.navVisible = false
        state.pcActiveId = null
        state.mActiveId = null
        state.beforePcActiveId = null
        state.beforeMActiveId = null
        state.appActiveIdVal = null
        state.appActiveId = null
        state.beforeAppActiveId = null
      },
      pcActiveIdVal: null,
      mActiveIdVal: null,
      appActiveIdVal: null,
      pcActiveId: null,
      mActiveId: null,
      appActiveId: null,
      beforePcActiveId: null,
      beforeMActiveId: null,
      beforeAppActiveId: null,
      navVisible: false,
      warningAlert: true,
      mixParams: {
        peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
        mixId: null, // mixId，编辑时必传，新增不传
        colId: null // collectionId
      },
      mixPagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      mixVisible: false,
      mixDetailVisible: false,
      navActiveTab: '1',
      initPc: false,
      initM: false,
      initApp: false,
      saveActive: () => {
        let pcActiveId_ = null
        let mActiveId_ = null
        let appActiveId_ = null
        let beforePcActiveId_ = null
        let beforeMActiveId_ = null
        let params = {
          ...state.searchParams,
          activeIds: [],
          unActiveIds: [],
          versionId: state.navActiveTab === '1' ? 0 : 1
        }
        if (state.searchParams.terminalId === 1) {
          if ([null, '', undefined].includes(state.pcActiveId)) {
            message.warning('PC端导航不能为空！')
            return
          }
          if ([null, '', undefined].includes(state.mActiveId)) {
            message.warning('M端导航不能为空！')
            return
          }
          let pcOpt = state.pcOptions.find(v => v.id === state.pcActiveId)
          if (!pcOpt && state.pcActiveIdVal) {
            pcOpt = state.pcOptions.find(v => v.label === state.pcActiveIdVal)
          }
          if (!pcOpt) {
            message.warning('请从下拉选项中选取数据！')
            return
          }
          pcActiveId_ = pcOpt.id
          params.activeIds[0] = pcActiveId_

          let mOpt = state.mOptions.find(v => v.id === state.mActiveId)
          if (!mOpt && state.mActiveIdVal) {
            mOpt = state.mOptions.find(v => v.label === state.mActiveIdVal)
          }
          if (!mOpt) {
            message.warning('请从下拉选项中选取数据！')
            return
          }
          mActiveId_ = mOpt.id
          params.activeIds[1] = mActiveId_

          if (
            pcActiveId_ !== state.beforePcActiveId &&
            ![null, undefined, '', NaN].includes(state.beforePcActiveId) &&
            ![null, undefined, '', NaN].includes(pcActiveId_)
          ) {
            beforePcActiveId_ =
              state.beforePcActiveId === pcActiveId_
                ? null
                : state.beforePcActiveId
          }

          if (
            mActiveId_ !== state.beforeMActiveId &&
            ![null, undefined, '', NaN].includes(state.beforeMActiveId) &&
            ![null, undefined, '', NaN].includes(mActiveId_)
          ) {
            beforeMActiveId_ =
              state.beforeMActiveId === mActiveId_
                ? null
                : state.beforeMActiveId
          }
          params.unActiveIds = [beforePcActiveId_, beforeMActiveId_].filter(
            v => v !== null
          )
        } else {
          if ([null, '', undefined].includes(state.appActiveId)) {
            message.warning('导航不能为空！')
            return
          }
          let appOpt = state.appOptions.find(v => v.id === state.appActiveId)
          if (!appOpt && state.appActiveIdVal) {
            appOpt = state.appOptions.find(
              v => v.label === state.appActiveIdVal
            )
          }
          if (!appOpt) {
            message.warning('请从下拉选项中选取数据！')
            return
          }
          appActiveId_ = appOpt.id
          params.activeIds[0] = appActiveId_
        }
        if (state.postParams.subChannel === -1) {
          const tempUnActiveIds = Array.isArray(state.appUnActiveIds)
            ? state.appUnActiveIds
            : state.appUnActiveIds != null
            ? [state.appUnActiveIds]
            : []
          if (
            state.arraysEqualUnordered(params.activeIds, tempUnActiveIds) &&
            tempUnActiveIds.length
          ) {
            message.warning('历史导航和当前数据一致，请勿滥点保存！')
            return
          }
          params.unActiveIds = tempUnActiveIds.filter(
            id => !params.activeIds.includes(id)
          )
        }

        nav_active_post_(params, state)
      },
      arraysEqualUnordered: (a, b) => {
        if (a.length !== b.length) return false
        return [...a].sort().every((val, idx) => val === [...b].sort()[idx])
      },
      mixVisibleChange: (mixVisible = false) => {
        if (mixVisible) {
          state.getMixList()
        }
        state.mixVisible = mixVisible
      },
      mixShowDetail: ({ mixId }) => {
        state.mixDetailVisible = true
        state.getMixDetail({ mixId })
      },
      openTheme: () => {
        state.getStrate()
        state.getNavList()
        state.getThemeList()
        state.fetchTopBar()
        state.themeVisible = true
      },
      checkMixCol: async (colId, mixType = 1) => {
        let params = {
          peerShowFlag: state.mixParams.peerShowFlag,
          ...state.searchParams,
          colId,
          mixType
        }
        if (state.mixParams.mixId !== null) {
          params.mixId = state.mixParams.mixId
        }
        const { success, retInfo } = await mixCol_checkMixCol_post_({
          ...params
        })

        if (success) {
          console.log('')
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      addMixData: () => {
        state.mixDetailVisible = true
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      pcOptions: [],
      mOptions: [],
      appOptions: [],
      getNav: (
        navType = 'header',
        subChannel = 1,
        init = false,
        unActiveIds = null
      ) => {
        const params = {
          ...state.searchParams,
          navType,
          subChannel,
          versionId: state.navActiveTab === '1' ? 0 : 1
        }

        if (unActiveIds) {
          params.unActiveIds = unActiveIds
        }
        if (subChannel === -1 && state.appOptions.length) {
          let value =
            state.appOptions.filter(
              v => v.navName === unActiveIds || v.id === unActiveIds
            )[0]?.id || null
          state.appUnActiveIds = value ? [value] : []
        }
        if (!init && (unActiveIds === null || unActiveIds === undefined)) {
          const nameVal =
            state[
              subChannel === 1
                ? 'pcActiveIdVal'
                : subChannel === -1
                ? 'appActiveIdVal'
                : 'mActiveIdVal'
            ]
          params.navName = nameVal
        }

        nav_get_post_(params, state, init)
      },
      deal: (params = {}) => {
        const { type = 1, name = null } = params
        state.dealType = 1
        state.type = type
        state.dealName = name
        if (type === 3 || type === 4) {
          state.navVisible = true
          state.navActiveTab = '1'
          if (state.searchParams.terminalId === 1) {
            state.getNav(type === 3 ? 'header' : 'footer', 1, true)
            state.getNav(type === 3 ? 'header' : 'footer', 2, true)
            state.dealName = type === 3 ? 'header' : 'footer'
          } else {
            state.dealName = 'header'
            state.getNav('header', -1, true)
          }
        } else if (type === 2) {
          state.router.push({
            name: 'TopBarList',
            query: {
              ...state.searchParams,
              type
            }
          })
        } else {
          state.jumpPage({ ...params, ...state.searchParams, type })
        }
      },
      type: 1,
      dealType: 1,
      dealName: null,
      cancelEditMix: () => {
        state.mixDetailVisible = false
        state.mixParams = {
          peerShowFlag: 0, // 分体是否一行展示，0-否，1-是
          mixId: null, // mixId，编辑时必传，新增不传
          colId: null // collectionId
        }
        state.mixDataSource = [
          {
            priority: null,
            colId: null,
            crossNum: null
          }
        ]
      },
      mixColDetailList: [{ colId: null, crossNum: null, priority: null }],
      getMixDetail: async ({ mixId }) => {
        const {
          success,
          data,
          retInfo
        } = await mixCol_getMixColDetail_mixId_get_({
          mixId
        })
        if (success) {
          const { mixColDetailList, mixId, peerShowFlag, colId } = data
          state.mixParams = { ...state.mixParams, mixId, peerShowFlag, colId }
          if (mixColDetailList.length === 0) {
            state.mixDataSource = [
              {
                priority: null,
                colId: null,
                crossNum: null
              }
            ]
          } else {
            state.mixDataSource = [...mixColDetailList]
          }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      relieveMix: async ({ id = null }) => {
        if (!id) {
          message.warning('未传入ID！')
          return
        }
        const { retInfo, success } = await mixCol_remove_mixId_get_({
          mixId: id
        })
        if (success) {
          message.success(retInfo)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      removeMixDataSource: index => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index, 1)
        state.mixDataSource = [...mixDataSource]
      },
      saveMixCol: async (successTitle = '修改') => {
        let hasError = false
        if (state.mixParams.colId === '' || state.mixParams.colId === null) {
          if (state.warningAlert) {
            hasError = true
            state.warningAlert = false
            message.warning('混合商品Collection ID必填')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          return
        }
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.map((v, index = 0) => {
          v.priority = index - 0 + 1
          if (v.colId === '' || v.colId === null) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('collection ID必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
          if (
            v.crossNum === '' ||
            v.crossNum === null ||
            v.crossNum - 0 === 0
          ) {
            if (state.warningAlert) {
              state.warningAlert = false
              message.warning('穿插个数必填')
              setTimeout(() => {
                state.warningAlert = true
              }, 3000)
            }
            hasError = true
            return
          }
        })
        if (!state.mixParams.colId || state.mixParams.colId === '') {
          if (state.warningAlert) {
            state.warningAlert = false
            message.warning('未填写混合商品Collection ID！')
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
          hasError = true
          return
        }
        if (hasError) {
          return
        }
        const { success, retInfo } = await mixCol_saveMixCol_post_({
          ...state.mixParams,
          ...state.searchParams,
          mixColDetailList: [...mixDataSource]
        })
        if (success) {
          message.success(`${successTitle}成功!`)
          state.getMixList()
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      getMixList: async () => {
        const { success, data, retInfo } = await mixCol_page_post_({
          ...state.searchParams,
          ...state.mixPagination
        })
        if (success) {
          const { list, pageNum, pageSize, total } = data
          state.mixPagination = { pageNum, pageSize, total }
          state.mixDataList = list
          if (list.length === 0) {
            state.mixDetailVisible = true
          } else {
            state.mixDetailVisible = false
          }
        } else {
          if (state.warningAlert) {
            if (retInfo === '' || retInfo === null) return
            state.warningAlert = false
            message.warning(retInfo)
            setTimeout(() => {
              state.warningAlert = true
            }, 3000)
          }
        }
      },
      mixDataList: [],
      activeKey: 'vacation',
      themeData: {},
      getThemeList: async () => {
        const { success, data, retInfo } = await theme_query_get({
          ...state.searchParams
        })
        if (success) {
          state.themeData = data
          data.themeConfigList.forEach(item => {
            item.themeConfigDetailList.forEach(i => {
              if (!i.lineColor) {
                i.lineColor = '#000000'
              }
            })
          })
        } else {
          message.error(retInfo)
        }
      },
      addMixDataSource: (index = 0) => {
        let mixDataSource = [...state.mixDataSource]
        mixDataSource.splice(index + 1, 0, {
          priority: null,
          colId: null,
          crossNum: null
        })
        state.mixDataSource = mixDataSource
      },
      mixDataSource: [
        {
          priority: null,
          colId: null,
          crossNum: null
        }
      ],
      checkLength: (key, len, text) => {
        switch (key) {
          case 'colId':
            if (
              state.mixParams.colId === null ||
              state.mixParams.colId === ''
            ) {
              message.warning('请填写混合商品Collection ID!')
            } else {
              state.mixParams.colId = state.mixParams.colId.substring(0, len)
            }
            break
          case 'colId_':
            if (text.colId === null || text.colId === '') {
              message.warning('请填写Collection ID!')
            } else {
              text.colId = text.colId.substring(0, len)
            }
            break
          case 'crossNum':
            if (
              text.crossNum === null ||
              text.crossNum === '' ||
              text.crossNum === 0
            ) {
              message.warning('穿插个数必填!')
            } else {
              text.crossNum = text.crossNum.substring(0, len)
            }
            break
        }
      },
      mixIndex: 0,
      mixCustomRow: (row, index) => {
        return {
          draggable: true,
          props: {
            draggable: true
          },
          sourceRowIndex: 0,
          onDragstart: e => {
            e.stopPropagation()
            state.mixIndex = index
          },
          onDragover: e => {
            e.preventDefault()
            state.mixIndex = index
          },
          onDrop: e => {
            e.stopPropagation()
            const row = state.mixDataSource.splice(state.mixIndex, 1)
            state.mixDataSource.splice(index, 0, ...row)
          }
        }
      },
      clicked: false,
      hovered: false,
      handleHoverChange: visible => {
        state.clicked = false
        state.hovered = visible
      },
      handleClickChange: visible => {
        state.clicked = visible
        state.hovered = false
      },
      hide: () => {
        state.clicked = false
        state.hovered = false
      },
      watchPage: e => {
        state.pagination.pageNum = e
        state.initList()
      },
      inputLengthCut: ({ val = null, key = null, len = 0 }) => {
        if (!val) return
        let value = val.split('').splice(0, len)
        state.postParams[key] = value.join('')
        if (key === 'seoTitle') {
          console.log('val', val)
        }
        if (key === 'name') {
          // 如果是修改标题
          if (state.postParams.colSeo && state.postParams.colSeo.seoUrl) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoUrl,
              type: 'colSeo',
              key: 'seoUrl',
              len: 255,
              reg: true
            })
          }

          if (state.postParams.colSeo && state.postParams.colSeo.seoTitle) {
            state.inputLengthCut({
              val: state.postParams.colSeo.seoTitle,
              type: 'colSeo',
              key: 'seoTitle',
              len: 70
            })
          }
        }
      },
      logVisible: false, // 日志弹窗
      col_activeCol_post: params => {
        col_activeCol_post_(params, state.initList)
      },
      col_queryColLog_post: params => {
        if (params.colId) {
          state.colId = params.colId
        }

        col_queryColLog_post_({ ...params }, state)
      },
      deleteFun: params => {
        col_deleteCol_post_(params, state.initList, state)
        params.showDel = false
      },
      value: null,
      route: useRoute(),
      router: useRouter(),
      jumpPage: (params = {}) => {
        state.router.push({
          path:
            params.type === 5
              ? 'CookieDetail'
              : params.type === 6
              ? 'FooterPolicyTerms'
              : params.type === 7
              ? 'ModuleAndLang'
              : 'PublicSetDetail',
          query: {
            ...state.route.query,
            ...params
          }
        })
      },
      dataSource: [],
      searchParams: {
        terminalId: 1,
        brandId: 1,
        channelId: 1,
        siteId: 1
      },
      brands: [],
      channels: [],
      sites: [],
      postParams: {
        navType: -1, // 导航类型 header footer
        subChannel: -1, // 适用终端 1 pc 2 M
        status: -1 // 状态 0 未使用 1 使用中
      },
      resetParams: () => {
        state.postParams = {
          navType: -1, // 导航类型 header footer
          subChannel: -1, // 适用终端 1 pc 2 M
          status: -1 // 状态 0 未使用 1 使用中
        }
        state.initList()
      },
      changeFilterTime: timeSet => {
        state.postParams = {
          ...state.postParams,
          createTimeBegin:
            timeSet === null || timeSet.length === 0 ? null : timeSet[0],
          createTimeEnd:
            timeSet === null || timeSet.length === 0 ? null : timeSet[1]
        }
      },
      deletePeopleGoodsFlag: (params = {}) => {
        let newParams = { ...params }
        delete newParams.peopleGoodsFlag
        return newParams
      },
      pagination: {
        pageNum: 1, // 当前页
        pageSize: 10, // 每页的数量
        total: 0 // 总记录数
      },
      resetPagination: () => {
        state.pagination = {
          pageNum: 1, // 当前页
          pageSize: 10, // 每页的数量
          total: 0 // 总记录数
        }
        state.initList()
      },
      logList: [],
      logPagination: {
        pageNum: 1, // 当前页
        pageSize: 5, // 每页的数量
        total: 0 // 总记录数
      },
      stragePc: [],
      strageM: [],
      navPc: [],
      navM: [],
      getNavList: async () => {
        const { success, data } = await nav_list_post({
          ...state.searchParams,
          navType: 'header',
          pageNum: 1,
          pageSize: 300
        })
        if (success) {
          const list = Array.isArray(data.list) ? data.list : []
          const fmt = it => ({ label: it.navName, value: it.id, id: it.id })
          const dedupe = arr => {
            const seen = new Set()
            const out = []
            for (const it of arr) {
              const key = String(it.navName)
              if (seen.has(key)) continue
              seen.add(key)
              out.push(fmt(it))
            }
            return out
          }
          if (+state.searchParams.terminalId === 1) {
            const pc = list
              .filter(item => +item.subChannel === 1 && +item.status === 1)
              .sort((a, b) => b.id - a.id)
            const m = list
              .filter(item => +item.subChannel === 2 && +item.status === 1)
              .sort((a, b) => b.id - a.id)
            state.navPc = dedupe(pc)
            state.navM = dedupe(m)
          } else {
            const m = list
              .filter(item => +item.status === 1)
              .sort((a, b) => b.id - a.id)
            state.navM = dedupe(m)
          }
        }
      },
      normalizeOptions: arr => {
        if (!Array.isArray(arr)) return []
        return arr
          .map(it => {
            const id = it.id ?? it.value
            const navName = it.navName ?? it.label ?? String(id ?? '')
            return {
              label: navName,
              value: navName,
              id,
              navName,
              status: it.status
            }
          })
          .sort((a, b) => b.id - 0 - (a.id - 0))
      },
      changeValue: (list, option, key) => {
        list[key] = option.label
      },
      getStrate: async () => {
        if (+state.searchParams.terminalId === 1) {
          const promise1 = homepage_strategy_list_post({
            ...state.searchParams,
            subTerminalId: 1,
            pageNum: 1,
            usingState: 1,
            pageSize: 100
          })
          const promise2 = homepage_strategy_list_post({
            ...state.searchParams,
            subTerminalId: 2,
            pageNum: 1,
            usingState: 1,
            pageSize: 100
          })
          Promise.all([promise1, promise2]).then(res => {
            state.stragePc = res[0].data.list.map(item => ({
              ...item,
              label: `${item.strategyId} - ${item.strategyName}`,
              value: item.strategyId
            }))
            state.strageM = res[1].data.list.map(item => ({
              ...item,
              label: `${item.strategyId} - ${item.strategyName}`,
              value: item.strategyId
            }))
          })
        } else {
          const { success, data } = await homepage_strategy_list_post({
            ...state.searchParams,
            pageNum: 1,
            pageSize: 100,
            usingState: 1
          })
          if (success) {
            state.strageM = data.list.map(item => ({
              ...item,
              label: `${item.strategyId} - ${item.strategyName}`,
              value: item.strategyId
            }))
          }
        }
      },
      handleSaveTheme: async () => {
        if (!state.themeData?.themeConfigList) {
          return
        }

        for (const theme of state.themeData.themeConfigList) {
          for (const list of theme.themeConfigDetailList) {
            if (+list.subTerminalId === 1 || list.subTerminalId === null) {
              if (!list.homepageId) {
                return message.error(
                  `${theme.themeType}下关联${
                    list.subTerminalId ? 'PC端' : ''
                  }首页策略不能为空`
                )
              }
              if (!list.navId) {
                return message.error(
                  `${theme.themeType}下${
                    list.subTerminalId ? 'PC端' : ''
                  }端关联导航不能为空`
                )
              }
            } else {
              if (!list.homepageId) {
                return message.error(
                  `${theme.themeType}下关联M端首页策略不能为空`
                )
              }
              if (!list.navId) {
                return message.error(`${theme.themeType}下M端关联导航不能为空`)
              }
            }
          }
          if (!theme?.themeTopbarConfigDetail?.topbarId) {
            const messages = `${theme.themeType}下关联topBar不能为空`
            return message.error(messages)
          }
        }
        const { success, retInfo } = await theme_save_post({
          ...state.searchParams,
          ...state.themeData
        })
        if (success) {
          message.success('保存成功')
          state.themeVisible = false
          state.initList()
        } else {
          message.error(retInfo)
        }
      },
      initList: () => {
        // if (state.route.query.terminalId) {
        //   state.searchParams.terminalId = state.route.query.terminalId - 0
        // }
        // if (state.route.query.brandId) {
        //   state.searchParams.brandId = state.route.query.brandId - 0
        // }
        // if (state.route.query.channelId) {
        //   state.searchParams.channelId = state.route.query.channelId - 0
        // }
        // if (state.route.query.siteId) {
        //   state.searchParams.siteId = state.route.query.siteId - 0
        // }
        commonConfig_list_post_(state)
      }, // 初始化标题列表
      topPopList: [],
      getTopPop: async () => {
        const { success, data } = await tobpop_list_post({
          ...state.searchParams
        })
        if (success) {
          state.topPopList = data
        }
      },
      topBarList: [],
      fetchTopBar: async () => {
        const { success, data } = await tobBar_list_post({
          ...state.searchParams
        })
        if (success) {
          state.topBarList = data.map(e => {
            return {
              ...e,
              label: e.id + (e.title ? ` - ${e.title}` : e.title),
              value: e.id
            }
          })
        }
      },
      changeTopBar: (themeTopbarConfigDetail, option, name) => {
        console.log('option', option)
        themeTopbarConfigDetail[name] = option?.title
      }
    })
    onMounted(() => {
      if (state.route.query.terminalId) {
        state.searchParams.terminalId = state.route.query.terminalId - 0
      }
      if (state.route.query.brandId) {
        state.searchParams.brandId = state.route.query.brandId - 0
      }
      if (state.route.query.channelId) {
        state.searchParams.channelId = state.route.query.channelId - 0
      }
      if (state.route.query.siteId) {
        state.searchParams.siteId = state.route.query.siteId - 0
        // state.router.replace({ query: {} })
      }
      common_querySiteInfo_get_({
        state
      })
      state.initList()
    })
    watch(
      () => state.navVisible,
      val => {
        if (!val) return
        state.navActiveTab = '1'
        state.initPc = true
        state.initM = true
        state.initApp = true
        state.pcActiveId = null
        state.mActiveId = null
        state.appActiveId = null
        state.beforePcActiveId = null
        state.beforeMActiveId = null
        state.beforeAppActiveId = null
        state.pcActiveIdVal = null
        state.mActiveIdVal = null
        state.appActiveIdVal = null
        state.appUnActiveIds = []
        if (state.searchParams.terminalId === 1) {
          state.getNav(state.dealName || 'header', 1, true)
          state.getNav(state.dealName || 'header', 2, true)
        } else {
          state.getNav('header', -1, true)
        }
      }
    )
    watch(
      () => state.pcOptions,
      arr => {
        const n = state.normalizeOptions(arr || [])
        if (JSON.stringify(arr || []) === JSON.stringify(n)) return
        state.pcOptions = n
        if (state.initPc) {
          const enabled = n.find(o => +o.status === 1)
          if (enabled) {
            state.pcActiveIdVal = enabled.label
            state.pcActiveId = enabled.id
          } else {
            state.pcActiveIdVal = null
            state.pcActiveId = null
          }
          state.initPc = false
        } else if (state.pcActiveId != null) {
          const opt = n.find(o => o.id === state.pcActiveId)
          if (opt) state.pcActiveIdVal = opt.label
        }
      },
      { deep: false }
    )
    watch(
      () => state.mOptions,
      arr => {
        const n = state.normalizeOptions(arr || [])
        if (JSON.stringify(arr || []) === JSON.stringify(n)) return
        state.mOptions = n
        if (state.initM) {
          const enabled = n.find(o => +o.status === 1)
          if (enabled) {
            state.mActiveIdVal = enabled.label
            state.mActiveId = enabled.id
          } else {
            state.mActiveIdVal = null
            state.mActiveId = null
          }
          state.initM = false
        } else if (state.mActiveId != null) {
          const opt = n.find(o => o.id === state.mActiveId)
          if (opt) state.mActiveIdVal = opt.label
        }
      },
      { deep: false }
    )
    watch(
      () => state.appOptions,
      arr => {
        const n = state.normalizeOptions(arr || [])
        if (JSON.stringify(arr || []) === JSON.stringify(n)) return
        state.appOptions = n
        if (state.initApp) {
          const enabled = n.find(o => +o.status === 1)
          if (enabled) {
            state.appActiveIdVal = enabled.label
            state.appActiveId = enabled.id
          } else {
            state.appActiveIdVal = null
            state.appActiveId = null
          }
          state.initApp = false
        } else if (state.appActiveId != null) {
          const opt = n.find(o => o.id === state.appActiveId)
          if (opt) state.appActiveIdVal = opt.label
        }
      },
      { deep: false }
    )
    watch(
      () => state.navActiveTab,
      () => {
        if (state.navVisible) {
          state.initPc = true
          state.initM = true
          state.initApp = true
          state.pcActiveId = null
          state.mActiveId = null
          state.appActiveId = null
          state.beforePcActiveId = null
          state.beforeMActiveId = null
          state.beforeAppActiveId = null
          state.pcActiveIdVal = null
          state.mActiveIdVal = null
          state.appActiveIdVal = null
          state.appUnActiveIds = []
          if (state.searchParams.terminalId === 1) {
            state.getNav(state.dealName, 1, true)
            state.getNav(state.dealName, 2, true)
          } else {
            state.getNav(state.dealName, -1, true)
          }
        }
      }
    )
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
